var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3"},[_c('div',{staticClass:"mt-2 lead"},[_c('font-awesome-icon',{staticClass:"text-success",attrs:{"size":"5x","icon":"fa-light fa-check-circle"}}),_c('div',{staticClass:"mt-1"},[_vm._v(" "+_vm._s(_vm.$t("Your subscription is active"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }